<h2 style="padding: 10px">Pedidos</h2>

<div class="custom-toolbar">
  <div class="custom-filter">
    <input
      type="text"
      placeholder="Buscar solicitud..."
      [(ngModel)]="filtro"
      (keyup)="aplicarFiltro()"
    />

    <button *ngIf="filtro" class="clear-btn" (click)="limpiarFiltro()">
      ✕
    </button>
  </div>

  <button class="btn-crear" (click)="agregarPedido()">
    <span>➕</span> Crear solicitud
  </button>
</div>

<app-pedidos-lista
  [pedidos]="pedidos"
  (changeEmmiter)="obtenerChangeEmisor()"
  [filtro]="filtro"
></app-pedidos-lista>
